import axios from "axios";

import { GeoPlace } from "@/types";

interface NominatimAddress {
  city?: string;
  state?: string;
  country?: string;
  street?: string;
  road?: string;
  postcode?: string;
  house_number?: string;
  village?: string;
  town?: string;
  county?: string;
  [key: string]: string | undefined;
}

interface NominatimPlace {
  place_id: number;
  lat: string;
  lon: string;
  display_name: string;
  address?: NominatimAddress;
}

export type SearchPlacesGeoRequest = {
  q?: string;
};

export type SearchPlacesGeoResponse = Array<GeoPlace>;

export const searchPlacesGeo = async (body: SearchPlacesGeoRequest): Promise<SearchPlacesGeoResponse> => {
  const { data } = await axios<NominatimPlace[]>("https://nominatim.openstreetmap.org/search", {
    params: {
      q: body.q?.trim(),
      format: "json",
      addressdetails: 1,
      limit: 20,
      "accept-language": "en-US",
    },
  });

  const mappedPlaces = data.map((place) => {
    const coordinates: [number, number] = [parseFloat(place.lon), parseFloat(place.lat)];

    return {
      value: `${place.place_id}`,
      label: place.display_name,
      optionLabel: place.display_name,
      coordinates,
    };
  });

  return mappedPlaces;
};
